module.exports = __webpack_public_path__ + "img/bb.46ad4126.svg";